export const Chars = {
    NBSP: String.fromCharCode(160),
    ARROW_RIGHT: String.fromCharCode(8594),
}
